import * as React from 'react';
export const webhookSvg = React.forwardRef(function webhookSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.431 12.346a3.81 3.81 0 0 0 3.757 3.154c2.103 0 3.812-1.7 3.812-3.803a3.808 3.808 0 0 0-3.812-3.803c-.403 0-.796.06-1.168.178l-.51-.888a3.775 3.775 0 0 0 1.327-2.88A3.808 3.808 0 0 0 8.025.5a3.808 3.808 0 0 0-3.812 3.803c0 1.146.507 2.176 1.314 2.874l-.521.897a3.807 3.807 0 0 0-1.194-.19A3.808 3.808 0 0 0 0 11.687a3.808 3.808 0 0 0 3.812 3.803 3.81 3.81 0 0 0 3.755-3.15l.864.006ZM8.025 2a2.308 2.308 0 0 0-2.312 2.303c0 .85.459 1.594 1.155 1.994a.75.75 0 0 1 .375.68.746.746 0 0 1-.1.407l-2.683 4.61a.75.75 0 0 1-1.296-.754l1.059-1.82A2.308 2.308 0 0 0 1.5 11.687a2.308 2.308 0 0 0 2.312 2.303 2.31 2.31 0 0 0 2.312-2.313h.006a.75.75 0 0 1 .749-.84l5.383.03a.75.75 0 0 1-.008 1.5l-2.282-.013A2.312 2.312 0 0 0 12.188 14a2.308 2.308 0 0 0 2.312-2.303 2.308 2.308 0 0 0-2.312-2.303 2.28 2.28 0 0 0-1.147.299.75.75 0 0 1-1.11-.506l-2.556-4.45a.75.75 0 1 1 1.3-.747l1.066 1.856c.37-.406.596-.947.596-1.543A2.308 2.308 0 0 0 8.025 2Z',
    }),
  );
});
webhookSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var webhook = {
  category: 'icon',
  colorable: true,
  name: 'webhook',
  svg: webhookSvg,
};
